import sliderRandomized from './scripts.js';

export default () => {
  document.addEventListener('DOMContentLoaded', () => {
    const componentNodes = Array.from(document.querySelectorAll('[data-component="slider-randomized"]'));

    componentNodes.forEach(sliderRandomized);
  });
};
